import React from 'react';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import clsx from 'clsx';

const Container = styled.div`
  ${tw`mx-auto px-2 md:px-4 lg:px-6 xl:px-8`}
`;

export type Size = '3xl' | '4xl' | '5xl' | '6xl' | '7xl';
const contentSize: Record<Size, any> = {
  '3xl': tw`max-w-3xl`,
  '4xl': tw`max-w-4xl`,
  '5xl': tw`max-w-5xl`,
  '6xl': tw`max-w-6xl`,
  '7xl': tw`max-w-7xl`,
};

export function NarrowContainer({
  children,
  className,
  width = '3xl',
}: {
  children: React.ReactNode;
  className?: string;
  width?: Size;
}) {
  return (
    <div className={clsx(className)} tw="mx-auto px-2 md:px-4 lg:px-6 xl:px-8">
      <div css={[contentSize[width], tw`mx-auto min-h-0`]}>{children}</div>
    </div>
  );
}

export default Container;
